<div class="p-4 bg-white">
  <img
    src="assets/svg/x.svg"
    alt=""
    class="close-button"
    (click)="close()"
    width="14px"
    height="14px"
  />
  <div class="row">
    <div class="d-flex">
      <img src="../../../../assets/svg/dollar.svg" alt="" />
      <h1 class="my-auto ms-2">Detalle de transacción</h1>
    </div>
    <div class="mt-4">
      <p class="label-title">ID</p>
      <p class="label-information">{{ transactionInfo?._id }}</p>
      <hr />
      <p class="label-title">Empresa contratista</p>
      <p class="label-information">{{ transactionInfo?.companyName || "-" }}</p>
      <hr />
      <p class="label-title">Administrador</p>
      <p class="label-information">{{ transactionInfo?.adminName || "-" }}</p>
      <hr />
      <p class="label-title">Legal Entity</p>
      <p class="label-information">{{ transactionInfo?.legalEntity || "-" }}</p>
      <hr />
      <p class="label-title">Depositado en</p>
      <p
        class="label-information"
        *ngIf="transactionInfo?.bank?.name != 'Transbank'"
      >
        {{ transactionInfo?.bank?.name || "-" }} en la cuenta Nº{{
          transactionInfo?.reference || "-"
        }}
      </p>
      <p
        class="label-information"
        *ngIf="transactionInfo?.bank?.name == 'Transbank'"
      >
        Transbank via Prepago
      </p>
      <hr />
      <!--  <p class="label-title">CUIT</p>
          <p class="label-information">111111-1</p>
          <hr>
          <p class="label-title">Servicio Brindado</p>
          <p class="label-information">14 de Septiembre a las 13:45 Hrs.</p>
          <hr>-->
      <p class="label-title">Fecha y hora de transacción</p>
      <p class="label-information">
        {{ formatDate(transactionInfo?.createDate, "d") + " " }} de
        {{ formatDate(transactionInfo?.createDate, "MMMM") + " " }} a las
        {{ formatDate(transactionInfo?.createDate, "h:mm") + " " }}Hrs.
      </p>
      <hr />

      <span class="label-title">Sub total: </span>
      <span class="float-end label-amount"
        >${{ transactionInfo?.amount || 0 | currency: "CLP":"":"1.0" }}</span
      >
      <br />
      <br />
      <span class="label-title">IVA: </span>
      <span class="float-end label-amount"
        >${{ transactionInfo?.iva || 0 | currency: "CLP":"":"1.0" }}</span
      >
      <br />
      <br />
      <span class="label-title">TOTAL:</span>
      <span class="float-end label-amount blue"
        >${{ transactionInfo?.total || 0 | currency: "CLP":"":"1.0" }}</span
      >
      <hr />

      <div class="float-end d-flex gap-4">
        <button
          class="btn btn-dark btn-block my-auto"
          [disabled]="transactionInfo.voucher == null"
          (click)="downloadInvoice(transactionInfo.voucher)"
        >
          Descargar detalle
        </button>
      </div>
    </div>
  </div>
</div>
